import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormGroup, Label, FormFeedback, FormText } from 'reactstrap';
import Datetime from 'react-datetime';
import classnames from 'classnames';
import 'moment/locale/hu';

import './DateTimePickerFieldGroup.css';

class DateTimePickerFieldGroup extends Component {
    render() {
        const { field, value, label, error, onChange, description, className } = this.props;

        return (
            <FormGroup className={className}>
                <Label for={field}>{label}</Label>
                <Datetime
                    className={classnames({ 'is-invalid': error })}
                    name={field}
                    value={value}
                    onChange={(mom) => {
                        const e = {
                            target: {
                                name: field,
                                value: mom
                            }
                        }
                        onChange(e);
                    }}
                    inputProps={{
                        name: field,
                        onChange: (e) => { e.preventDefault() }
                    }} />
                {error && <FormFeedback>{error}</FormFeedback>}
                {description && <FormText>{description}</FormText>}
            </FormGroup>
        );
    }
}

DateTimePickerFieldGroup.propTypes = {
    field: PropTypes.string.isRequired,
    value: PropTypes.object,
    label: PropTypes.string.isRequired,
    error: PropTypes.string,
    onChange: PropTypes.func.isRequired
}

export default DateTimePickerFieldGroup;
